var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup281(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-1500 -109.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(1503.5 112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M22.833,24.5A1.632,1.632,0,0,0,24.5,22.833c0-1.667-1.667-6.667-10-6.667s-10,5-10,6.667A1.632,1.632,0,0,0,6.167,24.5ZM6.175,22.927v0Zm.028-.093H22.8l.024,0,.013,0a4.45,4.45,0,0,0-1.387-2.773c-1.087-1.086-3.132-2.219-6.947-2.219s-5.86,1.133-6.947,2.22a4.463,4.463,0,0,0-1.387,2.773Zm16.624.093v0ZM14.5,12.833A3.333,3.333,0,1,0,11.167,9.5,3.333,3.333,0,0,0,14.5,12.833Zm5-3.333a5,5,0,1,1-5-5A5,5,0,0,1,19.5,9.5Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(1500 109.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 16.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup281);
export default __webpack_public_path__ + "static/media/Group 281.d4b0496a38b53cfebcc1414d17b0a79f.svg";
export { ForwardRef as ReactComponent };